import { HTMLAttributes, forwardRef } from 'react';

import { WithStyles, createStyles, withStyles } from '@material-ui/core';

import classNames from 'classnames';

const styles = createStyles({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'var(--background-base)',
    padding: 'var(--encore-spacing-tighter-4) var(--encore-spacing-tighter-2)',
    borderRadius: 'var(--encore-corner-radius-base)',
    flexWrap: 'wrap',
    gap: 'var(--encore-spacing-tighter-4)',
  },
  noWrap: {
    flexWrap: 'nowrap',
  },
});

export interface ExpressionGroupProps
  extends HTMLAttributes<HTMLDivElement>,
    WithStyles<typeof styles> {
  disableWrap?: boolean;
}

const ExpressionGroup = forwardRef<HTMLDivElement, ExpressionGroupProps>(
  (props, ref) => {
    const { classes, className, disableWrap, style, ...rest } = props;
    return (
      <div
        ref={ref}
        className={classNames(
          className,
          classes.root,
          disableWrap && classes.noWrap,
        )}
        style={style}
        {...rest}
      />
    );
  },
);

ExpressionGroup.displayName = 'Expression.Group';

export default withStyles(styles)(ExpressionGroup);
